import React from "react";
import Header from "../Header";
import Footer from "../Footer";
import Game from "../Game";
import HowToPlayPopup from "../HowToPlayPopup";
import AdSense from "../AdSense";
import ContentSection from "../ContentSection";

import { Toaster } from "../ui/toaster";
import PuzzleDataProvider from "../../providers/PuzzleData";
import GameStatusProvider from "../../providers/GameStatus";
import AuthProvider from "../../providers/Auth";
import ProgressProvider from "../../providers/Progress";
import { Analytics } from "@vercel/analytics/react";

function App() {
    const [isHowToPlayOpen, setIsHowToPlayOpen] = React.useState(false);

    return (
        <AuthProvider>
            <PuzzleDataProvider>
                <ProgressProvider>
                    <GameStatusProvider>
                        <div className="wrapper">
                            <Toaster />
                            <Header onOpenHowToPlay={() => setIsHowToPlayOpen(true)} />
                            <main className="flex flex-col items-center w-full max-w-2xl mx-auto space-y-4">
                                <HowToPlayPopup
                                    open={isHowToPlayOpen}
                                    onClose={() => setIsHowToPlayOpen(false)}
                                />
                                <Game />
                            </main>
                            {/* Ad between game and content section */}
                            <div className="w-full max-w-2xl mx-auto my-4">
                                <AdSense
                                    adSlot="9242166127"
                                    adFormat="horizontal"
                                    style={{ minHeight: '90px' }}
                                />
                            </div>
                            <ContentSection />
                            <Footer />
                        </div>
                    </GameStatusProvider>
                </ProgressProvider>
            </PuzzleDataProvider>
            <Analytics />
        </AuthProvider>
    );
}

export default App;
